__turbopack_context__.v({
  "description": "generic-small-card-module__OLtwQq__description",
  "environmentalIcon": "generic-small-card-module__OLtwQq__environmentalIcon",
  "environmentalWrapper": "generic-small-card-module__OLtwQq__environmentalWrapper",
  "genericSmallCard": "generic-small-card-module__OLtwQq__genericSmallCard",
  "title": "generic-small-card-module__OLtwQq__title",
  "titleWrapper": "generic-small-card-module__OLtwQq__titleWrapper",
});
